import $ from "jquery";
import moment from "moment";
import { Klass, csl, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

const { app } = window;

function addFuncHeader(vuw) {
	if( !( vuw instanceof Klass("Vuw") ) ) {
		throw new TypeError("arguments[0] must be Vuw instance.");
	}
	
	vuw.add("funcHeader", {
		vuwType: "funcBlock",
		_buttonText: {
			register: "新規登録",
			csv: {
				output: "CSV出力",
				input: "CSV入力"
			}
		},
		
		selector() {
			return $("<div/>").addClass("func-header")
			.appendTo(this.container.$content);
		},
		
		onReady($self) {
			$self
			// [新規登録ボタン]
			.on("click", ".btn-register", e => {
				e.preventDefault();
				vuwer.setState("v", "edit");
			})
			
			// [CSV出力ボタン]
			.on("click", ".btn-csv-output", async e => {
				const method = "csv-output";
				const { module } = app;
				
				e.preventDefault();
				
				app.showLoading(method);
				await module.createCsv(async (err, res) => {
					if(err) {
						return false;
					}
					
					if(!res.csv) {
						app.alert("対象のデータがありません");
						return false;
					}
					
					const { config } = module;
					const filename = config.csv.output.filename || module.getDataKey();
					
					this.$dlLink = $("<a/>").addClass("hide").attr({
						href: config.fileDir + res.csv,
						download: `${filename}${moment().format(".YYYYMMDD.HHmmss")}.csv`
					}).appendTo(this.$self);
					
					this.$dlLink.get(0).click();
					
					await new Promise(async resolve => setTimeout(resolve, 100));
					
					this.$dlLink.remove();
					delete this.$dlLink;
					
					return app.initList();
				}).catch(
					error => csl.warn("An error is catched.", { error })
				);
				
				app.hideLoading(method);
			})
			
			// [CSV入力ボタン]
			.on("click", ".btn-csv-input", e => {
				e.preventDefault();
				app.popup.showContents("csv-uploader");
			});
		},
		
		// [override refresh function]
		refresh() {
			this.$self.empty();
			
			const { config } = app.module;
			
			if(!config.dataParams || !app.config.account) {
				return this;
			}
			
			const def = this._buttonText;
			const buttonText = {};
			
			if(
				app.module.getDataKey() !== "users" ||
				app.config.account.lv !== "users"
			) {
				buttonText.register = def.register;
			}
			
			if( u_.isObject(config.csv) ) {
				buttonText.csv = {};
				
				if( u_.isObject(config.csv.output) ) {
					buttonText.csv.output = config.csv.output.buttonText || def.csv.output;
				}
				
				if( u_.isObject(config.csv.input) ) {
					buttonText.csv.input = config.csv.input.buttonText || def.csv.input;
				}
			}
			
			this.$self.append( this._createButtons(buttonText) );
			
			return true;
		}
	});
}

export default addFuncHeader;
